@if (filterType$ | async; as filterType) {
  <form [formGroup]="form">
    @if (filterType == 'boolean') {
      <label class="switch switch-text switch-pill switch-primary">
        <input
          type="checkbox"
          class="switch-input"
          formControlName="boolValue" />
        <span class="switch-label" data-on="Yes" data-off="No"></span>
        <span class="switch-handle"></span>
      </label>
    }
    @if (basicValueFilterTypes.includes(filterType)) {
      <input
        class="form-control form-control-sm me-2 adjust-up"
        type="text"
        name="filterField"
        placeholder="Filter by {{ form.controls.filterField?.value?.label }}"
        formControlName="textValue" />
    }
    <!-- time -->
    @if (timeFilterTypes.includes(filterType)) {
      <mypayter-portal-range-filter
        [rangeType$]="filterType$"
        formControlName="dateRangeValue"></mypayter-portal-range-filter>
    }
    <!-- ordinal, to add this option to the types, add it to the filterTypes field of the filterFields see apps/mypayter-portal/src/app/legacy/features/terminal-park/overview/overview.component.ts for example -->
    @if (ordinalFilterTypes.includes(filterType)) {
      <mypayter-portal-range-filter
        [rangeType$]="filterType$"
        formControlName="rangeValue"></mypayter-portal-range-filter>
    }
    <!-- since value, runtime range than to now -->
    @if (sinceTypes.includes(filterType)) {
      <mypayter-portal-since
        formControlName="sinceValue"
        [filterType$]="filterType$"></mypayter-portal-since>
    }
  </form>
}
